const options = {
  1: "xl:row-end-1",
  2: "xl:row-end-2",
};

export default function getGridRowEndXl(end) {
  return options[end];
}
